import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Row, Col, Card, CardBody, Button, Spinner,
  FormGroup, Label, Input, CardHeader,
} from 'reactstrap'
import DeleteRecordByAdmin from '../../components/Modal/DeleteRecordByAdmin'
import MaskedInput from '../../components/Template/Input/MaskedInput'
import Select from '../../components/Template/Input/Select'
import DataTable from '../../components/Template/Table/DataTable'
import { getCityTypes, getStateTypes, getCompanySegmentTypes } from '../../store/ducks/types'
import { getLegalEntities } from '../../store/ducks/admin'
import oikosApi from '../../services/oikos'
import { notifyError, notifySuccess } from '../../utils/notify'

class LegalPerson extends Component {
  constructor(props) {
    super(props)
    this.state = {
      person: null,

      addPersonModalIsOpen: false,
      addPersonIsLoading: false,

      editPersonModalIsOpen: false,
      editPersonIsLoading: false,

      deleteRecordModalIsOpen: false,
      deleteRecordId: null,
      deleteRecordName: '',
    }
  }

  componentDidMount() {
    const { getCityTypes, getStateTypes, getCompanySegmentTypes, getLegalEntities } = this.props

    getLegalEntities()
    getCityTypes()
    getStateTypes()
    getCompanySegmentTypes()
  }

  toggleModal = (type) => {
    const {
      addPersonIsLoading, editPersonIsLoading,
      addPersonModalIsOpen, editPersonModalIsOpen,
    } = this.state

    if (addPersonIsLoading || editPersonIsLoading) {
      return null
    }

    if (type === 'add') {
      this.setState(prevState => ({
        addPersonModalIsOpen: !prevState.addPersonModalIsOpen,
      }))

      if (addPersonModalIsOpen) this.setState({ person: null })
    } else if (type === 'edit') {
      this.setState(prevState => ({
        editPersonModalIsOpen: !prevState.editPersonModalIsOpen,
      }))

      if (editPersonModalIsOpen) this.setState({ person: null })
    }

    return null
  }

  handleAddPersonSubmit = async () => {
    const { person } = this.state
    if (!person.pj_nomefanta) person.pj_nomefantaInvalid = true
    if (!person.pj_razaosocial) person.pj_razaosocialInvalid = true

    if (person.pj_nomefanta && person.pj_razaosocial) {
      try {
        this.setState({ addPersonIsLoading: true })

        delete person.pj_nomefantaInvalid
        delete person.pj_razaosocialInvalid

        const body = {
          action: 'insert',
          table: 'pj',
          data: {
            ...person,
            pj_nomefanta: person.pj_nomefanta ? person.pj_nomefanta : undefined,
            pj_razaosocial: person.pj_razaosocial ? person.pj_razaosocial : undefined,
            pj_cnpj: person.pj_cnpj ? person.pj_cnpj : undefined,
            pj_insEst: person.pj_insEst ? person.pj_insEst : undefined,
            pj_insMun: person.pj_insMun ? person.pj_insMun : undefined,
            areaAtua_id: person.areaAtua_id ? person.areaAtua_id : undefined,
            pj_emailPrin: person.pj_emailPrin ? person.pj_emailPrin : undefined,
            pj_emailSec: person.pj_emailSec ? person.pj_emailSec : undefined,
            pj_site: person.pj_site ? person.pj_site : undefined,
            pj_telPrin: person.pj_telPrin ? person.pj_telPrin : undefined,
            pj_telSec: person.pj_telSec ? person.pj_telSec : undefined,
            pj_contato: person.pj_contato ? person.pj_contato : undefined,
            pj_endLogr: person.pj_endLogr ? person.pj_endLogr : undefined,
            pj_endNum: person.pj_endNum ? person.pj_endNum : undefined,
            pj_endCompl: person.pj_endCompl ? person.pj_endCompl : undefined,
            pj_cep: person.pj_cep ? person.pj_cep : undefined,
            uf_id: person.uf_id ? person.uf_id : undefined,
            mun_id: person.mun_id ? person.mun_id : undefined,
          },
        }

        console.log('body handleAddPersonSubmit', body)

        const res = await oikosApi.post('/', body)

        console.log('res handleAddPersonSubmit', res)

        this.setState({ addPersonIsLoading: false, addPersonModalIsOpen: false })
        notifySuccess('Registro adicionado com sucesso.')
        this.props.getLegalEntities()
      } catch (e) {
        this.setState({ addPersonIsLoading: false })
        notifyError('Não foi possível adicionar o registro.')
        console.tron.log('Não foi possível adicionar o registro.', e)
      }
    } else {
      this.setState({ person })
      window.scrollTo(0, 0)
    }
  }

  handleEditPersonSubmit = async () => {
    const { person } = this.state
    if (!person.pj_nomefanta) person.pj_nomefantaInvalid = true
    if (!person.pj_razaosocial) person.pj_razaosocialInvalid = true

    if (person.pj_nomefanta && person.pj_razaosocial) {
      try {
        this.setState({ addPersonIsLoading: true })

        delete person.pj_nomefantaInvalid
        delete person.pj_razaosocialInvalid

        const body = {
          action: 'update',
          table: 'pj',
          data: {
            ...person,
            pj_nomefanta: person.pj_nomefanta ? person.pj_nomefanta : undefined,
            pj_razaosocial: person.pj_razaosocial ? person.pj_razaosocial : undefined,
            pj_cnpj: person.pj_cnpj ? person.pj_cnpj : undefined,
            pjTp_id: person.pjTp_id ? person.pjTp_id : undefined,
            pj_perfInter: person.pj_perfInter ? person.pj_perfInter : undefined,
            pais_id: person.pais_id ? person.pais_id : undefined,
            sp: person.sp ? person.sp : undefined,
            pixTp_id: person.pixTp_id ? person.pixTp_id : undefined,
            contaDepTp_id: person.contaDepTp_id ? person.contaDepTp_id : undefined,
            kamino_id: person.kamino_id ? person.kamino_id : undefined,
            pj_cliente: person.pj_cliente ? person.pj_cliente : undefined,
            pj_fornecedor: person.pj_fornecedor ? person.pj_fornecedor : undefined,
            pj_insEst: person.pj_insEst ? person.pj_insEst : undefined,
            pj_insMun: person.pj_insMun ? person.pj_insMun : undefined,
            areaAtua_id: person.areaAtua_id ? person.areaAtua_id : undefined,
            pj_emailPrin: person.pj_emailPrin ? person.pj_emailPrin : undefined,
            pj_emailSec: person.pj_emailSec ? person.pj_emailSec : undefined,
            pj_site: person.pj_site ? person.pj_site : undefined,
            pj_telPrin: person.pj_telPrin ? person.pj_telPrin : undefined,
            pj_telSec: person.pj_telSec ? person.pj_telSec : undefined,
            pj_contato: person.pj_contato ? person.pj_contato : undefined,
            pj_endLogr: person.pj_endLogr ? person.pj_endLogr : undefined,
            pj_endNum: person.pj_endNum ? person.pj_endNum : undefined,
            pj_endCompl: person.pj_endCompl ? person.pj_endCompl : undefined,
            pj_cep: person.pj_cep ? person.pj_cep : undefined,
            uf_id: person.uf_id ? person.uf_id : undefined,
            mun_id: person.mun_id ? person.mun_id : undefined,
          },
        }

        console.log('body handleAddPersonSubmit', body)

        const res = await oikosApi.post('/', body)

        console.log('res handleAddPersonSubmit', res)

        this.setState({ addPersonIsLoading: false, addPersonModalIsOpen: false })
        notifySuccess('Registro adicionado com sucesso.')
        this.props.getLegalEntities()
      } catch (e) {
        this.setState({ addPersonIsLoading: false })
        notifyError('Não foi possível adicionar o registro.')
        console.tron.log('Não foi possível adicionar o registro.', e)
      }
    } else {
      this.setState({ person })
      window.scrollTo(0, 0)
    }
  }

  render() {
    const {
      person,
      addPersonModalIsOpen, addPersonIsLoading,
      editPersonModalIsOpen, editPersonIsLoading,
      deleteRecordModalIsOpen, deleteRecordId, deleteRecordName,
    } = this.state

    const {
      getCityTypesIsLoading, cityTypes,
      getStateTypesIsLoading, stateTypes,
      getCompanySegmentTypesIsLoading, companySegmentTypes,
    } = this.props.types

    const {
      getLegalEntitiesIsLoading, legalEntities,
    } = this.props.admin

    return (
      <>
        {addPersonModalIsOpen && (
          <>
            <Row>
              <Col>
                <h4>
                  Adicionar registro
                </h4>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button color="light" size="sm" onClick={() => this.toggleModal('add')}>
                  <i className="ri-close-fill font-size-16" />
                </Button>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>
                    Geral
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col lg={6}>
                        <FormGroup>
                          <Label>
                            Nome fantasia
                          </Label>
                          <Input
                            value={person?.pj_nomefanta}
                            onChange={e => this.setState({ person: { ...person, pj_nomefanta: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg={6}>
                        <FormGroup>
                          <Label>
                            Razão social
                          </Label>
                          <Input
                            value={person?.pj_razaosocial}
                            onChange={e => this.setState({ person: { ...person, pj_razaosocial: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CNPJ
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCnpj = el}
                            mask="00.000.000/0000-00"
                            lazy={false}
                            value={person?.pj_cnpj?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pj_cnpj: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Inscrição Estadual
                          </Label>
                          <Input
                            value={person?.pj_insEst}
                            onChange={e => this.setState({ person: { ...person, pj_insEst: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Inscrição Municipal
                          </Label>
                          <Input
                            value={person?.pj_insMun}
                            onChange={e => this.setState({ person: { ...person, pj_insMun: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Área de atuação
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getCompanySegmentTypesIsLoading}
                            isDisabled={getCompanySegmentTypesIsLoading || !stateTypes}
                            options={companySegmentTypes}
                            value={companySegmentTypes?.filter(t => t.value === person?.areaAtua_id)}
                            onChange={e => this.setState({ person: { ...person, areaAtua_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Contato
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Email principal
                          </Label>
                          <Input
                            value={person?.pj_emailPrin}
                            onChange={e => this.setState({ person: { ...person, pj_emailPrin: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Email secundário
                          </Label>
                          <Input
                            value={person?.pj_emailSec}
                            onChange={e => this.setState({ person: { ...person, pj_emailSec: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Site
                          </Label>
                          <Input
                            value={person?.pj_site}
                            onChange={e => this.setState({ person: { ...person, pj_site: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone principal
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputTelPrin = el}
                            mask="(00) 0000-0000"
                            lazy={false}
                            value={person?.pj_telPrin?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pj_telPrin: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone secundário
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputTelSec = el}
                            mask="(00) 0000-0000"
                            lazy={false}
                            value={person?.pj_telSec?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pj_telSec: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Contato
                          </Label>
                          <Input
                            value={person?.pj_contato}
                            onChange={e => this.setState({ person: { ...person, pj_contato: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Endereço
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Logradouro
                          </Label>
                          <Input
                            value={person?.pj_endLogr}
                            onChange={e => this.setState({ person: { ...person, pj_endLogr: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Número
                          </Label>
                          <Input
                            value={person?.pj_endNum}
                            onChange={e => this.setState({ person: { ...person, pj_endNum: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Complemento
                          </Label>
                          <Input
                            value={person?.pj_endCompl}
                            onChange={e => this.setState({ person: { ...person, pj_endCompl: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CEP
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCep = el}
                            mask="00000-000"
                            lazy={false}
                            value={person?.pj_cep?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pj_cep: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            UF
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getStateTypesIsLoading}
                            isDisabled={getStateTypesIsLoading || !stateTypes}
                            options={stateTypes}
                            value={stateTypes?.filter(t => t.value === person?.uf_id)}
                            onChange={e => this.setState({ person: { ...person, uf_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Município
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getCityTypesIsLoading}
                            isDisabled={getCityTypesIsLoading || !cityTypes}
                            options={cityTypes}
                            value={cityTypes?.filter(t => t.value === person?.mun_id)}
                            onChange={e => this.setState({ person: { ...person, mun_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <hr className="mt-2 mb-4" />
              </Col>
            </Row>

            <Row>
              <Col className="d-flex justify-content-end">
                <Button
                  type="button"
                  color="primary"
                  className="ml-3"
                  disabled={addPersonIsLoading}
                  onClick={() => this.handleAddPersonSubmit()}
                >
                  Enviar
                  {addPersonIsLoading && (
                    <Spinner size="sm" className="ml-2" />
                  )}
                </Button>
              </Col>
            </Row>
          </>
        )}

        {editPersonModalIsOpen && (
          <>
            <Row>
              <Col>
                <h4>
                  Editar registro
                </h4>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button color="light" size="sm" onClick={() => this.toggleModal('edit')}>
                  <i className="ri-close-fill font-size-16" />
                </Button>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>
                    Geral
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col lg={6}>
                        <FormGroup>
                          <Label>
                            Nome fantasia
                          </Label>
                          <Input
                            value={person?.pj_nomefanta}
                            onChange={e => this.setState({ person: { ...person, pj_nomefanta: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg={6}>
                        <FormGroup>
                          <Label>
                            Razão social
                          </Label>
                          <Input
                            value={person?.pj_razaosocial}
                            onChange={e => this.setState({ person: { ...person, pj_razaosocial: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CNPJ
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCnpj = el}
                            mask="00.000.000/0000-00"
                            lazy={false}
                            value={person?.pj_cnpj?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pj_cnpj: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Inscrição Estadual
                          </Label>
                          <Input
                            value={person?.pj_insEst}
                            onChange={e => this.setState({ person: { ...person, pj_insEst: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Inscrição Municipal
                          </Label>
                          <Input
                            value={person?.pj_insMun}
                            onChange={e => this.setState({ person: { ...person, pj_insMun: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Área de atuação
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getCompanySegmentTypesIsLoading}
                            isDisabled={getCompanySegmentTypesIsLoading || !stateTypes}
                            options={companySegmentTypes}
                            value={companySegmentTypes?.filter(t => t.value === person?.areaAtua_id)}
                            onChange={e => this.setState({ person: { ...person, areaAtua_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Contato
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Email principal
                          </Label>
                          <Input
                            value={person?.pj_emailPrin}
                            onChange={e => this.setState({ person: { ...person, pj_emailPrin: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Email secundário
                          </Label>
                          <Input
                            value={person?.pj_emailSec}
                            onChange={e => this.setState({ person: { ...person, pj_emailSec: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Site
                          </Label>
                          <Input
                            value={person?.pj_site}
                            onChange={e => this.setState({ person: { ...person, pj_site: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone principal
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputTelPrin = el}
                            mask="(00) 0000-0000"
                            lazy={false}
                            value={person?.pj_telPrin?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pj_telPrin: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Telefone secundário
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputTelSec = el}
                            mask="(00) 0000-0000"
                            lazy={false}
                            value={person?.pj_telSec?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pj_telSec: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Contato
                          </Label>
                          <Input
                            value={person?.pj_contato}
                            onChange={e => this.setState({ person: { ...person, pj_contato: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    Endereço
                  </CardHeader>
                  <CardBody>
                    <Row xs={1} sm={2} lg={4}>
                      <Col>
                        <FormGroup>
                          <Label>
                            Logradouro
                          </Label>
                          <Input
                            value={person?.pj_endLogr}
                            onChange={e => this.setState({ person: { ...person, pj_endLogr: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Número
                          </Label>
                          <Input
                            value={person?.pj_endNum}
                            onChange={e => this.setState({ person: { ...person, pj_endNum: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Complemento
                          </Label>
                          <Input
                            value={person?.pj_endCompl}
                            onChange={e => this.setState({ person: { ...person, pj_endCompl: e.target.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            CEP
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputCep = el}
                            mask="00000-000"
                            lazy={false}
                            value={person?.pj_cep?.toString()}
                            onAccept={value => this.setState({ person: { ...person, pj_cep: value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            UF
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getStateTypesIsLoading}
                            isDisabled={getStateTypesIsLoading || !stateTypes}
                            options={stateTypes}
                            value={stateTypes?.filter(t => t.value === person?.uf_id)}
                            onChange={e => this.setState({ person: { ...person, uf_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Município
                          </Label>
                          <Select
                            isSearchable
                            isClearable
                            isLoading={getCityTypesIsLoading}
                            isDisabled={getCityTypesIsLoading || !cityTypes}
                            options={cityTypes}
                            value={cityTypes?.filter(t => t.value === person?.mun_id)}
                            onChange={e => this.setState({ person: { ...person, mun_id: e?.value } })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <hr className="mt-2 mb-4" />
              </Col>
            </Row>

            <Row>
              <Col className="d-flex justify-content-end">
                <Button
                  type="button"
                  color="primary"
                  className="ml-3"
                  disabled={editPersonIsLoading}
                  onClick={() => this.handleEditPersonSubmit()}
                >
                  Enviar
                  {editPersonIsLoading && (
                    <Spinner size="sm" className="ml-2" />
                  )}
                </Button>
              </Col>
            </Row>
          </>
        )}

        {!addPersonModalIsOpen && !editPersonModalIsOpen && (
          <>
            <DeleteRecordByAdmin
              isOpen={deleteRecordModalIsOpen}
              recordId={deleteRecordId}
              recordType="pj"
              recordName={deleteRecordName}
              toggle={() => this.setState({
                deleteRecordModalIsOpen: !deleteRecordModalIsOpen,
              })}
            />

            <Row>
              <Col>
                <h4>
                  Lista
                </h4>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button outline color="primary" onClick={() => this.toggleModal('add')}>
                  Adicionar
                </Button>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardBody className="pb-1">
                    {getLegalEntitiesIsLoading && (
                      <Row>
                        <Col className="d-flex align-items-center justify-content-center py-3">
                          <Spinner size="sm" />
                        </Col>
                      </Row>
                    )}

                    {!getLegalEntitiesIsLoading && legalEntities && (
                      <DataTable
                        data={{
                          columns: [
                            {
                              label: 'ID',
                              field: 'pj_id',
                            },
                            {
                              label: 'Nome',
                              field: 'pj_nomefanta',
                            },
                            {
                              label: 'CNPJ',
                              field: 'pj_cnpj',
                            },
                            {
                              label: 'Ações',
                              field: 'actions',
                            },
                          ],
                          rows: legalEntities.map(person => ({
                            ...person,
                            actions: (
                              <div>
                                <Button
                                  size="sm"
                                  color="light"
                                  onClick={() => {
                                    this.setState({ person, editPersonModalIsOpen: true })
                                  }}
                                >
                                  <i className="ri-pencil-fill" />
                                </Button>

                                <Button
                                  size="sm"
                                  color="light"
                                  className="ml-2"
                                  onClick={() => this.setState({
                                    deleteRecordModalIsOpen: true,
                                    deleteRecordId: person.pj_id,
                                    deleteRecordName: person.pj_nomefanta,
                                  })}
                                >
                                  <i className="ri-delete-bin-6-line" />
                                </Button>
                              </div>
                            ),
                          })),
                        }}
                      />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </>
    )
  }
}

const mapStateToProps = state => ({
  types: state.types,
  admin: state.admin,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getCityTypes,
  getStateTypes,
  getCompanySegmentTypes,
  getLegalEntities,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(LegalPerson)
